/**
 * Featured Collections Slider
 * Section: featured-collections.liquid
 * Figma Desktop: 179-2757 | Mobile: 627-21280
 *
 * Desktop: 4 slides visible, gap 32px, nav arrows enabled.
 * Mobile:  ~1.5 slides visible (250px + peek), no arrows, touch only.
 * Waits for Swiper to be available (loaded via theme.liquid defer).
 */

(function () {
  var BREAKPOINTS = { mobile: 768 };

  function initFeaturedCollections() {
    var sections = document.querySelectorAll('[data-featured-collections]');

    sections.forEach(function (section) {
      if (section.dataset.collectionsInitialized === 'true') return;

      var swiperEl = section.querySelector('[data-collections-swiper]');
      if (!swiperEl) return;

      if (typeof Swiper === 'undefined') return;

      var prevBtn = section.querySelector('[data-collections-prev]');
      var nextBtn = section.querySelector('[data-collections-next]');

      var swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        loop: false,
        watchOverflow: true,

        // Desktop: show 4 full slides. Mobile: 250px cards, bleed right.
        breakpoints: {
          769: {
            spaceBetween: 32
          }
        },

        navigation: (prevBtn && nextBtn) ? {
          prevEl: prevBtn,
          nextEl: nextBtn
        } : false,

        // Keep disabled state on nav buttons via Swiper's built-in class
        watchSlidesProgress: true
      });

      section.dataset.collectionsInitialized = 'true';
      section._collectionsSwiper = swiper;
    });
  }

  // Wait for Swiper to be ready — it's loaded defer so may not be available
  // immediately when this script runs.
  function waitForSwiper(callback, attempts) {
    attempts = attempts || 0;
    if (typeof Swiper !== 'undefined') {
      callback();
    } else if (attempts < 20) {
      setTimeout(function () {
        waitForSwiper(callback, attempts + 1);
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForSwiper(initFeaturedCollections);
    });
  } else {
    waitForSwiper(initFeaturedCollections);
  }

  // Re-init on Shopify theme editor section load
  document.addEventListener('shopify:section:load', function () {
    waitForSwiper(initFeaturedCollections);
  });

})();
